import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
export class FeatureGreenFishProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return !this.forceResponsive
            && this.fish && other.fish && this.fish.red && other.fish.red && this.fish.red.equals(other.fish.red)
            && this.bowl && other.bowl && this.bowl.equals(other.bowl)
            && this.bubble && other.bubble && this.bubble.equals(other.bubble)
            && this.bubbleLocations && other.bubbleLocations && this.bubbleLocations.length === other.bubbleLocations.length
            && this.bubbleLocations.every((value, index) => value.equals(other.bubbleLocations[index]))
            && this.pickedPrize && other.pickedPrize && this.pickedPrize.equals(other.pickedPrize)
            && this.missedPrize && other.missedPrize && this.missedPrize.equals(other.missedPrize)
            && this.titleText && other.titleText && this.titleText.equals(other.titleText)
            && this.helpText && other.helpText && this.helpText.equals(other.helpText)
            && this.logoProperties && other.logoProperties && this.logoProperties.equals(other.logoProperties)
            && this.collectAllAnimation && other.collectAllAnimation && this.collectAllAnimation.equals(other.collectAllAnimation)
            && this.equals(other);
    }
}
//# sourceMappingURL=FeatureGreenFishProperties.js.map